export const MAX_MEDIA_LEVELS = 3
export const MAX_MEDIA_BREADCRUMBS_LENGTH = 3
export const MEDIA_PAGINATION_SIZE = 15
